/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by sjacobs on 8/23/18.
 */
function ExternalIngestTypeModalController(this: JS5Object, _: JS5Object, UtilsService: JS5Object) {

    this.$onInit = () => {
        this.externalIngestTypes = _.values(UtilsService.externalIngestTypes);
    };

    this.onDone = (): void => {
        this.close({$value: this.externalIngestType.value});
    };
}

angular
    .module('prism-ui.components')
    .component(
        'externalIngestTypeModal',
        {
            controller: ExternalIngestTypeModalController,
            templateUrl: 'components/modal/externalIngest/externalIngestTypeModal/external-ingest-type-modal-template.html',
            bindings: {
                resolve: '<',
                close: '&',
                dismiss: '&'
            }
        }
    );
